import React from "react";
import { Ribbon } from "lucide-react";

// Public role badge (2026-02): a small ROSETTE — deliberately distinct from
// the trust SHIELD (TrustChip) and the recognition MEDAL (TierBadge).
// Display-only, factual: the role label, nothing more. Hover explains.
export const RoleBadge = ({ badge, className = "" }) => {
  if (!badge?.label) return null;
  return (
    <span
      data-testid={`role-badge-${badge.role}`}
      title={`Verified: ${badge.label}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium align-middle bg-indigo-50 text-indigo-700 border border-indigo-200 ${className}`}
    >
      <Ribbon className="w-3 h-3" />
      {badge.label}
    </span>
  );
};
